import React from 'react';
import PropTypes from 'prop-types';
import {
  numberFormat,
  maskAccount,
  getDueDate,
} from '../../constants/constants';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Link from '@material-ui/core/Link';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
import TimerTwoToneIcon from '@material-ui/icons/TimerTwoTone';
import CancelDialog from '../common/cancel-dialog/cancel-dialog';
import Hidden from '@material-ui/core/Hidden';
import Title from '../common/custom-components/customTitle1Header';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import moment from 'moment';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import _ from 'lodash';
import './agent-home.css';
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bolder',
    flex: 1,
    flexShrink: 0,
    color: 'white',
  },
  subHeading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bolder',
    flex: 1,
    flexShrink: 0,
  },
  secondaryHeading: {
    flex: 1,
    flexShrink: 0,
    fontSize: theme.typography.pxToRem(15),
    color: '#606060',
    fontFamily: 'Arial',
    wordBreak: 'break-all',
  },
  secondaryHeadingComment: {
    flex: 1,
    flexShrink: 0,
    fontSize: theme.typography.pxToRem(15),
    color: '#606060',
    fontFamily: 'Arial',
    // wordBreak: 'break-all',
  },
  ThirdHeading: {
    flexBasis: '20%',
    flexShrink: 0,
    fontSize: theme.typography.pxToRem(15),
    color: '#606060',
    fontFamily: 'Arial',
  },
  icon: {
    color: 'red',
  },
  icon2: {
    color: 'green',
  },
  link: {
    fontSize: 20,
    fontFamily: 'Arial',
  },
}));
export default function AgentHomeForm(props) {
  const classes = useStyles();
  console.log('Agent Home Form Data: ' + props.data);
  const getStatus = appStatus => {
    let status = appStatus;
    if (appStatus === 'PENDING_FOR_NOTARY') {
      status = (
        <span>
          READY_FOR_ <br /> SIGNATURES_ <br /> AND_NOTARY
        </span>
      );
    } else if (appStatus === 'READY_FOR_REVIEW') {
      status = 'PENDING_REVIEW';
    } else {
      return status;
    }
    return status;
  };

  const getComments = (activity, comments) => {
    let result = _.orderBy(
      activity,
      function (o) {
        return o.activityTimestamp;
      },
      ['desc'],
    );
    if (
      !_.isEmpty(result) &&
      (result[0].statusAddComments !== null ||
        _.isEmpty(result[0].statusAddComments)) &&
      comments !== null
    ) {
      return (
        <span>
          {comments[0] !== null && !_.isEmpty(comments) && (
            <span>
              {comments.map(item => (
                <li key={item.id}>{item}</li>
              ))}
            </span>
          )}
          {result[0].statusAddComments !== null &&
            result[0].activityStatus !== 'READY_FOR_REVIEW' &&
            !_.isEmpty(result[0].statusAddComments) && (
              <li key={2}>{result[0].statusAddComments}</li>
            )}
        </span>
      );
    } else if (
      result !== undefined &&
      result[0].statusAddComments !== undefined &&
      (result[0].statusAddComments === null ||
        _.isEmpty(result[0].statusAddComments)) &&
      comments !== null
    ) {
      return comments[0];
    } else if (
      (_.isEmpty(result[0].statusAddComments) ||
        result[0].statusAddComments !== null) &&
      comments === null
    ) {
      return result[0].statusAddComments;
    } else {
      return result[0].statusComments;
    }
  };
  return (
    <div className="auth-page">
      <div className="container page">
        <div>
          <div className="header">
            <Hidden only="xs">
              <div className="header-flex">
                <Title text="Surety Bond Applications" />
              </div>
              <div>
                <Link
                  className={classes.link}
                  component="button"
                  variant="body2"
                  onClick={props.viewinfoPage}
                >
                  Create new application
                </Link>
              </div>
            </Hidden>
          </div>
          <Hidden only={['sm', 'md', 'lg', 'xl']}>
            <div className="header-flex">
              <Title text="Surety Bond Applications" size="27px" />
            </div>
            <div className="app-link">
              <Link
                className={classes.link}
                component="button"
                variant="body2"
                onClick={props.viewinfoPage}
              >
                Create new application
              </Link>
            </div>
          </Hidden>
        </div>
        <div className={classes.root}>
          <Hidden only="xs">
            <ExpansionPanel
              expanded={false}
              style={{ backgroundColor: '#0073a8' }}
            >
              <ExpansionPanelSummary
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Hidden only="xs">
                  <Typography className={classes.heading}>
                    Application Date
                  </Typography>

                  <Typography className={classes.heading}>
                    Bond Number
                  </Typography>
                </Hidden>
                <Typography className={classes.heading}>
                  Company Name
                </Typography>
                <Hidden only="xs">
                  <Typography className={classes.heading}>
                    Bill Account
                  </Typography>
                </Hidden>
                <Typography className={classes.heading}>
                  Application Status
                </Typography>

                <Link
                  onClick={props.handleRefreshHomePage}
                  color="primary"
                  component="button"
                  variant="h6"
                  className={classes.heading}
                >
                  <RefreshIcon style={{ verticalAlign: 'middle' }} />
                  Refresh
                </Link>
              </ExpansionPanelSummary>
            </ExpansionPanel>
            {props &&
              props.data &&
              props.data.map((a, index) => (
                <ExpansionPanel key={index}>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="Agent-application-content"
                    id="panel1bh-header"
                    key={index}
                  >
                    <Hidden only="xs">
                      <Typography className={classes.secondaryHeading}>
                        {a.submitted}
                      </Typography>
                      <Typography className={classes.secondaryHeading}>
                        {a.bondNumber}
                      </Typography>
                    </Hidden>
                    <Typography className={classes.secondaryHeading}>
                      {a.companyName}
                    </Typography>
                    <Hidden only="xs">
                      <Typography
                        className={classes.secondaryHeading}
                        style={{ textAlign: 'center' }}
                      >
                        {maskAccount(a.billAccount, 5)}
                      </Typography>
                    </Hidden>
                    <Typography className={classes.secondaryHeading}>
                      {getStatus(a.appStatus)}
                    </Typography>
                    {(a.appStatus === 'READY_FOR_REVIEW' ||
                      a.appStatus === 'PENDING_FINAL_REVIEW') && (
                      <Typography
                        className={classes.secondaryHeading}
                        style={{ textAlign: 'center' }}
                      >
                        <HourglassEmptyOutlinedIcon color="primary" />
                      </Typography>
                    )}
                    {a.appStatus === 'AWAITING_ORIGINALS' && (
                      <Typography
                        className={classes.secondaryHeading}
                        style={{ textAlign: 'center' }}
                      >
                        <TimerTwoToneIcon color="primary" />
                      </Typography>
                    )}
                    {a.appStatus === 'BOND_INSTALLED' && (
                      <Typography
                        className={classes.secondaryHeading}
                        style={{ textAlign: 'center' }}
                      >
                        <CheckCircleIcon className={classes.icon2} />
                      </Typography>
                    )}
                    {a.appStatus === 'REJECTED' && (
                      <Typography
                        className={classes.secondaryHeading}
                        style={{ textAlign: 'center' }}
                      >
                        <CancelOutlinedIcon className={classes.icon} />
                      </Typography>
                    )}
                    {(a.appStatus === 'PENDING_CORRECTIONS' ||
                      a.appStatus === 'PENDING_CONTRACT_CORRECTIONS') && (
                      <Typography
                        className={classes.secondaryHeading}
                        style={{ textAlign: 'center' }}
                      >
                        <ReportProblemIcon className={classes.icon} />
                      </Typography>
                    )}
                    {a.appStatus === 'PENDING_FOR_NOTARY' && (
                      <Typography
                        className={classes.secondaryHeading}
                        style={{ textAlign: 'center' }}
                      >
                        <CheckCircleOutlineIcon className={classes.icon2} />
                      </Typography>
                    )}
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails key="22">
                    <Hidden only="xs">
                      <Typography className={classes.subHeading}>
                        Last Updated
                      </Typography>
                      <Typography className={classes.subHeading}>
                        Due Date
                      </Typography>
                    </Hidden>
                    <Typography className={classes.subHeading}>
                      Bond Amount
                    </Typography>

                    <Typography className={classes.subHeading}>
                      Comments
                    </Typography>
                    {a.appStatus !== 'AWAITING_ORIGINALS' && (
                      <Typography className={classes.subHeading} />
                    )}
                  </ExpansionPanelDetails>
                  <ExpansionPanelDetails>
                    <Hidden only="xs">
                      <Typography className={classes.secondaryHeading}>
                        {a.currentStatusTimeStamp}
                      </Typography>
                      <Typography className={classes.secondaryHeading}>
                        {getDueDate(a.depositDueDate, moment)}
                      </Typography>
                    </Hidden>
                    <Typography className={classes.secondaryHeading}>
                      {numberFormat(a.depositBondAmt)}
                    </Typography>

                    <Typography className={classes.secondaryHeadingComment}>
                      {getComments(a.activity, a.appComments)}
                      {a.appStatus === 'AWAITING_ORIGINALS' && (
                        <div>
                          <strong>
                            Please retain a copy of the
                            Surety&nbsp;Bond&nbsp;contract and send original to:
                          </strong>
                          <div className="address-box">
                            <strong className="text-xs-center">
                              {' '}
                              FPL, Attention:
                              <br /> RRD\LFO Deposit Administration,
                              <br /> 4200 W.Flagler Street,
                              <br /> Coral Gables, FL 33134.
                            </strong>
                          </div>
                        </div>
                      )}
                    </Typography>

                    <div className={classes.ThirdHeading}>
                      <div className="header">
                        {(a.appStatus === 'PENDING_CORRECTIONS' ||
                          a.appStatus === 'REJECTED' ||
                          a.appStatus === 'PENDING_FOR_NOTARY' ||
                          a.appStatus === 'PENDING_CONTRACT_CORRECTIONS') && (
                          <div className="button-space">
                            <Tooltip
                              title="View the Application"
                              placement="right"
                            >
                              <Link
                                component="button"
                                variant="h6"
                                color="primary"
                                value={a.id}
                                onClick={props.handleView}
                              >
                                View
                              </Link>
                            </Tooltip>
                          </div>
                        )}
                        {a.appStatus !== 'BOND_INSTALLED' && (
                          <div className="button-space">
                            <Tooltip
                              title="Delete the Applications"
                              placement="right"
                            >
                              <Link
                                component="button"
                                variant="h6"
                                color="primary"
                                value={a.id}
                                onClick={props.handleAgentHomeCancel}
                              >
                                Delete{' '}
                              </Link>
                            </Tooltip>
                            <CancelDialog
                              open={props.modalOpen}
                              delete={props.handleAppDelete}
                              close={props.handleModalClose}
                              content=""
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </ExpansionPanelDetails>
                  <ExpansionPanelDetails key={a.id}>
                    {a.pdfLink !== null &&
                      (a.appStatus === 'PENDING_CONTRACT_CORRECTIONS' ||
                        a.appStatus === 'PENDING_FINAL_REVIEW' ||
                        a.appStatus === 'AWAITING_ORIGINALS') && (
                        <div className="upload-link">
                          <a
                            rel="noopener noreferrer"
                            href={a.pdfLink}
                            target="_blank"
                          >
                            Uploaded Contract
                          </a>
                        </div>
                      )}
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
          </Hidden>
          <Hidden only={['sm', 'md', 'lg', 'xl']}>
            {props &&
              props.data &&
              props.data.map((a, index) => (
                <div key={index}>
                  {' '}
                  <Card className={classes.root} key={index}>
                    <CardContent>
                      <div className="header">
                        <div className="header-flex">
                          <Typography variant="h5" component="h2">
                            Application Status
                          </Typography>
                          <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                          >
                            {a.appStatus}
                          </Typography>
                        </div>

                        <div>
                          {(a.appStatus === 'READY_FOR_REVIEW' ||
                            a.appStatus === 'PENDING_FINAL_REVIEW') && (
                            <HourglassEmptyOutlinedIcon color="primary" />
                          )}
                          {a.appStatus === 'AWAITING_ORIGINALS' && (
                            <TimerTwoToneIcon color="primary" />
                          )}
                          {a.appStatus === 'BOND_INSTALLED' && (
                            <CheckCircleIcon className={classes.icon2} />
                          )}
                          {a.appStatus === 'REJECTED' && (
                            <CancelOutlinedIcon className={classes.icon} />
                          )}
                          {(a.appStatus === 'PENDING_CORRECTIONS' ||
                            a.appStatus === 'PENDING_CONTRACT_CORRECTIONS') && (
                            <ReportProblemIcon className={classes.icon} />
                          )}
                          {a.appStatus === 'PENDING_FOR_NOTARY' && (
                            <CheckCircleOutlineIcon className={classes.icon2} />
                          )}
                        </div>
                      </div>

                      <Typography variant="h5" component="h2">
                        Company Name
                      </Typography>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        SHORES UNITED, LLC
                      </Typography>

                      <Typography variant="h5" component="h2">
                        Application Date
                      </Typography>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        {a.submitted}
                      </Typography>
                      <Typography variant="h5" component="h2">
                        Bond No
                      </Typography>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        {a.bondNumber}
                      </Typography>
                      <Typography variant="h5" component="h2">
                        Bond Amount
                      </Typography>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        {numberFormat(a.depositBondAmt)}
                      </Typography>
                      <Typography variant="h5" component="h2">
                        Comments
                      </Typography>

                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        {getComments(a.activity, a.appComments)}
                        {a.appStatus === 'AWAITING_ORIGINALS' && (
                          <div>
                            <strong>
                              Please retain a copy of the
                              Surety&nbsp;Bond&nbsp;contract and send original
                              to:
                            </strong>
                            <div className="address-box">
                              <strong className="text-xs-center">
                                {' '}
                                FPL, Attention:
                                <br /> RRD\LFO Deposit Administration,
                                <br /> 4200 W.Flagler Street,
                                <br /> Coral Gables, FL 33134.
                              </strong>
                            </div>
                          </div>
                        )}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <div className="button-space-right">
                        {a.pdfLink !== null &&
                          (a.appStatus === 'PENDING_CONTRACT_CORRECTIONS' ||
                            a.appStatus === 'PENDING_FINAL_REVIEW' ||
                            a.appStatus === 'AWAITING_ORIGINALS') && (
                            <div className="text-xs-center">
                              <a
                                rel="noopener noreferrer"
                                href={a.pdfLink}
                                target="_blank"
                              >
                                Uploaded Contract
                              </a>
                            </div>
                          )}
                      </div>

                      <div className="header">
                        {(a.appStatus === 'PENDING_CORRECTIONS' ||
                          a.appStatus === 'REJECTED' ||
                          a.appStatus === 'PENDING_FOR_NOTARY' ||
                          a.appStatus === 'PENDING_CONTRACT_CORRECTIONS') && (
                          <div className="button-space-right">
                            <Tooltip
                              title="View the Application"
                              placement="right"
                            >
                              <Link
                                className="text-xs-center"
                                component="button"
                                variant="h6"
                                color="primary"
                                value={a.id}
                                onClick={props.handleView}
                              >
                                View
                              </Link>
                            </Tooltip>
                          </div>
                        )}

                        {a.appStatus !== 'BOND_INSTALLED' && (
                          <div className="button-space-mobile">
                            <Tooltip
                              title="Delete the Applications"
                              placement="right"
                            >
                              <Link
                                className="text-xs-center"
                                component="button"
                                variant="h6"
                                color="primary"
                                value={a.id}
                                onClick={props.handleAgentHomeCancel}
                              >
                                Delete{' '}
                              </Link>
                            </Tooltip>
                            <CancelDialog
                              open={props.modalOpen}
                              delete={props.handleAppDelete}
                              close={props.handleModalClose}
                              content=""
                            />
                          </div>
                        )}
                      </div>
                    </CardActions>
                  </Card>
                  <br />
                </div>
              ))}
          </Hidden>
        </div>
      </div>
    </div>
  );
}

AgentHomeForm.propTypes = {
  error: PropTypes.object,
  handleView: PropTypes.func,
  handleModalClose: PropTypes.func,
  handleAppDelete: PropTypes.func,
  handleRefreshHomePage: PropTypes.func,
  handleAgentHomeCancel: PropTypes.func,
  viewinfoPage: PropTypes.func,
  modalOpen: PropTypes.bool,
  invalid: PropTypes.func,
  submitting: PropTypes.func,
  pristine: PropTypes.func,
  data: PropTypes.array,
};
